module.exports = __webpack_public_path__ + "img/win_item3.0887e8bc.png";